import { ConfigProvider, DatePicker } from "antd";
import { getIn, useFormikContext } from "formik";
import dayjs from "dayjs";
import fr_FR from "antd/locale/fr_FR";
import ar_EG from "antd/locale/ar_EG";

const DatePickerInput = ({
    name,
    label,
    size = "middle",
    disabled = false,
    handleChange = () => { },
    placeholder = "Select Date",
    labelClassName = "",
    maxDate = null,
    minDate = null,
    initialViewDate = null,
    format = 'DD-MM-YYYY',
    showTime = null,
    className = null,
    isRequired = false
}) => {
    const { values, setFieldValue, setFieldTouched, errors, touched } = useFormikContext();
    const error = getIn(errors, name);
    const isTouched = getIn(touched, name);
    const value = getIn(values, name);
    const disabledDate = current => {
        if (minDate && current.isBefore(dayjs(minDate), 'day')) return true;
        if (maxDate && current.isAfter(dayjs(maxDate), 'day')) return true;
        return false;
    };

    const getDefaultPickerValue = () => {
        const raw = initialViewDate || maxDate || minDate || value;
        return dayjs(raw).isValid() ? dayjs(raw) : undefined;
    };


    return (
        <div className="relative" style={{position:'relative'}}>
            {label && <label className={labelClassName} htmlFor={name}>{label} {isRequired && <span className='text-red-600'>*</span>}</label>}
            <DatePicker
                id={name}
                name={name}
                placeholder={placeholder}
                value={value && dayjs(value).isValid() ? dayjs(value) : null}
                format={format}
                size={size}
                showTime={showTime}
                style={{ width: "100%" }}
                onChange={(date, dateString) => {
                    if (format === 'DD-MM-YYYY') {
                        setFieldValue(name, date ? date : null);
                    } else {
                        setFieldValue(name, date ? dateString : null);
                    }
                    handleChange(dateString);
                }}
                //onBlur={() => setFieldTouched(name, true)}
                status={error && isTouched ? "error" : ""}
                disabled={disabled}
                className={className ? className : "whitespace-normal break-words rounded-15"}
                disabledDate={(minDate || maxDate) ? disabledDate : undefined}
                defaultPickerValue={getDefaultPickerValue()}
            />
            {error && isTouched && (
                <span className={`input-error`}>
                    {error}
                </span>
            )}
        </div>
    );
};

export default DatePickerInput;
